module.exports = __webpack_public_path__ + "img/Symbol_6.2ff6abf4.png";